import { useState, useCallback } from 'react'
import { translations, detectLang } from '../i18n/translations'

export function useLang() {
  const [lang, setLangState] = useState(detectLang)

  const t = translations[lang]

  const setLang = useCallback((newLang) => {
    setLangState(newLang)
  }, [])

  return { lang, t, setLang }
}
